import {
  
    GET_CORRESPONDENCE_CATEGORY_DROPDOWN,
   
} from "../../api/commonRoutepath";
import request from "../../api/agent";
import { on } from "events";


// payer lookup 
export const searchPayerLookup = (props) => onResponse => {
 
};

// payee lookup 
export const searchPayeeLookup = (props) => onResponse => {
  

};
export const search837file = (props) => (onResponse) => {
  
};
export const search837fileAll = (id) => onResponse => {
 
};
export const createUpdate835Lite = (values) => onResponse => {
  

};
export const getCorrespondeceCategoryDropdown = () => onResponse => {
    try {
        request.get(GET_CORRESPONDENCE_CATEGORY_DROPDOWN)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const createOrUpdateCorres = (data) => onResponse => {
 

};
export const createOrUpdatePayment835 = (data) => onResponse => {
   

};
export const createOrUpdateDraft = (data) => onResponse => {
  

};
export const createOrUpdatePatientPay = (props) => onResponse => {
   

};
export const getEditGridData = (job) => onResponse => {
  
};
export const verifyPayerRc = (reasoncodes, payer_id) => onResponse => {
  

};
export const rejectFile = (job, reason, staff, description, qdx_reasons) => onResponse => {
  

};
export const rejectJob = (pk) => onResponse => {
  

};
export const checkExcludedPayer = (job_id, payer_id,facility_id='') => onResponse => {
  

};
export const getJobStaffStatus = (job_id) => onResponse => {
  

};
export const assignJobFromQa = (props) => onResponse => {
 
};
export const assignJobFromQaV2 = (data) => onResponse => {
  
};
export const exitGrid = (job, work_type, session_timeout = false) => onResponse => {
   

};

export const jobTimeout = (job) => onResponse => {
  
};


export const getSubJobUserData = (job) => onResponse => {
  
};

export const getValidateTaxIdData = (facility, tin, npi, client = "") => onResponse => {
  

};
export const getValidateNpiData = (facility, tin, npi, client = "") => onResponse => {
 
};
export const rerunAutomationJob = (data) => onResponse => {
  

};

export const getValidatecARCaNDrARC = (search, type) => onResponse => {
 

};
export const getPdfPrev = ( props) => onResponse => {
 

};